import { defineMessages } from 'react-intl'

export default defineMessages({
    placeholder: {
        defaultMessage: 'Selecciones las fotografías',
    },
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
    maxBytesSizeError: {
        defaultMessage: 'El tamaño máximo es {megas} MB',
    },
})
